import React, { useEffect, useState } from 'react';
import { Link } from 'react-router-dom';
import { MailX } from 'lucide-react';

const API = process.env.REACT_APP_BACKEND_URL;

// Rote Leiste für Admins, wenn der Server im Testmodus EMAIL_DRY_RUN läuft (keine echten E-Mails)
export const MailDryRunBanner = ({ user }) => {
  const [active, setActive] = useState(false);
  const isAdmin = user?.role === 'admin';

  useEffect(() => {
    if (!isAdmin) return;
    const token = localStorage.getItem('token');
    fetch(`${API}/api/admin/mail-credentials`, { headers: { Authorization: `Bearer ${token}` } })
      .then(r => (r.ok ? r.json() : null))
      .then(d => setActive(!!d?.email_dry_run))
      .catch(() => {});
  }, [isAdmin]);

  if (!isAdmin || !active) return null;
  return (
    <div data-testid="mail-dry-run-banner"
      className="flex-shrink-0 bg-red-700 text-white px-4 py-2 flex items-center gap-3 border-b-2 border-red-900 z-[99995]">
      <MailX className="w-4 h-4 flex-shrink-0" />
      <p className="text-xs sm:text-sm min-w-0">
        <span className="font-semibold">E-Mail-Versand im Testmodus:</span> Der Server läuft mit <code className="bg-white/15 px-1 rounded">EMAIL_DRY_RUN</code> – es werden
        <span className="font-semibold"> keine E-Mails versendet</span>, nur protokolliert.
        <span className="hidden sm:inline"> In der Produktion muss dieser Wert in den Deployment-Secrets auf <code className="bg-white/15 px-1 rounded">0</code> gesetzt und neu deployt werden.</span>
        <Link to="/portal/admin/mail-zugangsdaten" className="ml-2 underline underline-offset-2 whitespace-nowrap" data-testid="mail-dry-run-banner-link">Details</Link>
      </p>
    </div>
  );
};

export default MailDryRunBanner;
